import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

/**
 * Top Section of the Details Page
 */
export const DetailsContainer = styled.div<{ $padding?: string }>`
    display: flex;
    flex-direction: column;
    border-bottom: solid 1px ${tokens.border.default};
    padding: ${({ $padding }) => $padding ?? '3rem'};

    &:last-child {
        border-bottom: none;
    }
`;

/**
 * A section used for top details
 *
 * e.g. Base Station Logo + Name / Serial Number
 */
export const Section = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`;

/**
 * Columns grid container in the top section details
 */
export const DetailsColumns = styled.div`
    width: auto;
    max-width: 150rem;
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: 1fr;
    grid-template-areas: 'details-section';
    align-items: start;

    @media ${MediaQueries.xlargeAndUp} {
        grid-template-columns: repeat(auto-fill, minmax(40rem, 1fr));
        grid-template-areas: 'details-section';
    }
`;

/**
 * Details Section area in the Details Column
 * Use when we want to display the details in sections of 2
 *
 * e.g. Base Station Details Page
 */
export const DetailsSection = styled.div`
    display: grid;
    grid-auto-rows: auto;
    grid-template-areas: 'details-section';
    align-items: start;
`;

/**
 * Use when we want to display the details in a list form
 *
 * e.g. Repeaters Details Page
 */
export const DetailsList = styled.div`
    display: grid;
    grid-row: auto;
    grid-template-columns: repeat(auto-fill, minmax(40rem, 1fr));
    justify-content: start;
    align-items: start;
`;

export const DetailsGrid = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 2rem;
    row-gap: 1.2rem;
    font-size: 1.4rem;
`;
